import { getCometMcpServerName, isCometMcpSourceType, } from '#pplx/frontend/apps/ask/sources/types/cometMcpSourceTypes.js';
import { resolveSourceMentionIcon } from '#pplx/frontend/apps/ask/sources/utilities/resolveSourceMentionIcon.js';
import { defineMessage } from 'react-intl';
const premiumSourceLimitedMessage = defineMessage({
    defaultMessage: 'Monthly query limit reached',
    id: '0f0bc66e48',
    description: 'Subtitle shown on a premium source mention option when the monthly usage limit is reached',
});
export function getSourceMentionOptions({ sources, suggestedSources, isSourceConnected, getSource, getSourceLabel, getSourceLimited, cometMcpSources, handleMention, $t, }) {
    const getPremiumSourceMention = (sourceType) => {
        const limited = getSourceLimited(sourceType);
        const label = getSourceLabel(sourceType);
        return {
            label,
            uuid: sourceType,
            variant: 'sources',
            icon: getMentionSourceIcon({ sourceType, cometMcpSources }),
            action: () => handleMention(sourceType),
            disabled: limited,
            subtitle: limited ? $t(premiumSourceLimitedMessage) : undefined,
            convertToNode: true,
        };
    };
    const getSourceMention = (sourceType) => {
        const label = getSourceLabel(sourceType);
        return {
            label,
            uuid: sourceType,
            variant: 'sources',
            icon: getMentionSourceIcon({ sourceType, cometMcpSources }),
            action: () => handleMention(sourceType),
            convertToNode: true,
        };
    };
    // Combine suggested sources with all sources, keeping suggested sources first
    const orderedSources = new Set([...suggestedSources, ...sources]);
    return Array.from(orderedSources)
        .filter(isSourceConnected)
        .map((sourceType) => {
        const src = getSource(sourceType);
        if (src && 'is_premium' in src && src.is_premium) {
            return getPremiumSourceMention(sourceType);
        }
        return getSourceMention(sourceType);
    });
}
function getMentionSourceIcon({ sourceType, cometMcpSources, }) {
    const iconUrl = isCometMcpSourceType(sourceType)
        ? cometMcpSources[getCometMcpServerName(sourceType)]?.iconUrl
        : undefined;
    return resolveSourceMentionIcon({ sourceId: sourceType, iconUrl });
}
//# sourceMappingURL=getSourceMentionOptions.js.map